import { render, staticRenderFns } from "./OptionAutoPlayIntegration.vue?vue&type=template&id=50fa96ab&scoped=true&"
import script from "./OptionAutoPlayIntegration.vue?vue&type=script&lang=ts&"
export * from "./OptionAutoPlayIntegration.vue?vue&type=script&lang=ts&"
import style0 from "./OptionAutoPlayIntegration.vue?vue&type=style&index=0&id=50fa96ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fa96ab",
  null
  
)

export default component.exports